module.exports = __webpack_public_path__ + "img/seasonal-leaf-64.e1db7080.png";